<template>
  <el-dialog :title="title"
             :visible.sync="dialogFormVisible"
             custom-class="list-dialog"
             center
             :close-on-click-modal="false"
             :modal="true"
             :append-to-body="true">
    <div>
      <div class="search-content">
        <el-col :span="24" class="toobar">
          <el-input style="width:200px;" placeholder="请选择商品" v-model="seedname" clearable @click.native="showGoodDetailSel" @clear="clearSeedCode"></el-input>
          <el-select v-model="cangkucode" filterable style="width: 150px">
            <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                       :label="item.cangkuname"
                       :value="item.cangkucode">
            </el-option>
          </el-select>
          <el-input style="width:200px;"
                    placeholder="输入销售单号或采购单号"
                    prefix-icon="el-icon-search"
                    v-model="searchdata" clearable>
          </el-input>
          <el-date-picker
            v-model="date"
            type="month"
            :clearable="false"
            placeholder="选择日期">
          </el-date-picker>
          <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid">搜索</el-button>
          <el-button @click="excelPort" type="warning" v-if="showtab!=1">导出</el-button>
        </el-col>
      </div>
      <el-col :span="24">
        <el-col :span="24">
          <comment :is="currentcomponent" v-if="showtab==1&&filltemplate!=30" ref="referweibiao"
                   :initContent="initContent"
                   :cutHeight="118"></comment>
          <div v-if="filltemplate==30&&showtab==1">
            <el-col :span="2" style="text-align: right" v-if="showtab==1">右眼：</el-col>
            <el-col :span="6">
              <comment :is="currentcomponent" v-if="showtab==1" ref="referweibiaoright" :initContent="initContentRight"
                       :cutHeight="118"></comment>
            </el-col>
            <el-col :span="2" style="text-align: right" v-if="showtab==1">左眼：</el-col>
            <el-col :span="6">
              <comment :is="currentcomponent" v-if="showtab==1" ref="referweibiaoleft" :initContent="initContentLeft"
                       :cutHeight="118"></comment>
            </el-col>
          </div>
          <el-table
            :data="tableData" v-show="showtab!=1"
            :height="tableHeight(118)"
            size="mini"
            border
            style="width: 100%;">
            <el-table-column label="仓库" align="center" header-align="center" width="100" prop="cangkuname" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="日期" align="center" header-align="center" width="150" prop="accdate">
            </el-table-column>
            <el-table-column label="坏件入库单号" align="center" header-align="center" width="130">
              <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row.erpserial)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.erpserial}}
                  </span>
              </template>
            </el-table-column>
            <el-table-column label="关联单号" align="left" header-align="center" width="130">
              <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row.ordernum)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.ordernum}}
                  </span>
              </template>
            </el-table-column>
            <el-table-column label="采购单号" align="left" header-align="center" width="130" prop="buyordernum">
            </el-table-column>
            <el-table-column label="商品" align="center" header-align="center" width="150" prop="seedname" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="规格" align="left" header-align="center" width="180">
              <template slot-scope="scope">
                {{ getPackagesize(scope.row.packagesize) }}
              </template>
            </el-table-column>
            <el-table-column label="类别" align="left" header-align="center" width="90">
              <template slot-scope="scope">
                {{scope.row.formtype.toString() == '78' ? scope.row.ordername : scope.row.handlemode}}
              </template>
            </el-table-column>
            <el-table-column label="入库" align="right" header-align="center" width="70">
              <template slot-scope="scope">
                {{ scope.row.formtype.toString()=='78'&&scope.row.totalnumber != 0 ? scope.row.totalnumber :"" }}
              </template>
            </el-table-column>
            <el-table-column label="出库" align="right" header-align="center" width="70">
              <template slot-scope="scope">
                {{ scope.row.formtype.toString()=='79'&&scope.row.totalnumber != 0 ? scope.row.totalnumber :"" }}
              </template>
            </el-table-column>
            <el-table-column label="备注" header-align="center" prop="remark" :show-overflow-tooltip="true">
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="3" v-if="false">
          <el-tabs tab-position="right" @tab-click="tabClick" v-model="defaulttabname">
            <el-tab-pane label="待出库" name="daichuku" v-if="showtab"></el-tab-pane>
            <el-tab-pane label="查看明细" name="lookdetail"></el-tab-pane>
          </el-tabs>
        </el-col>
        <!--<div class="foot">-->
        <!--<Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>-->
        <!--</div>-->
      </el-col>
      <CstagreementEdit ref="CstagreementEdit"></CstagreementEdit>
      <StorageBadOut ref="StorageBadOut"></StorageBadOut>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
      <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    </div>
  </el-dialog>
</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import {getBadStoreListData} from '@/api/set/warehouse'
  import {completeddetail} from '@/api/set/jxcstoreformdetail'
  import TwoDimensionalView from '@/components/set/goodsprice/TwoDimensionalView';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import StorageBadOut from '@/components/warehouse/StorageBadOut'
  import BaoSunDetail from '@/components/testorder/cstagreement/BaoSunDetail';
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel'

  export default {
    name: 'StorageBadDetail',
    data() {
      return {
        msg: '汇总 坏件库明细页',
        userInfoModel: {},
        dialogFormVisible: false,
        searchdata: "",
        title: '',
        loading: true,
        seedname: '',
        seedcode: "",
        cangkucode: '',
        independentserial: "",
        showidd: false,
        jxcstoreData:[],
        date: '',
        canshowgoodsel:true,
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        ordernum: '',
        tableData: [],
        filltemplate: '',
        showtab: 2,
        currentcomponent: "",
        initContent: [],
        initContentLeft: [],
        initContentRight: [],
        defaulttabname: 'daichuku',
        formtype: '',
      }
    },
    methods: {
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
      },
      excelPort() {
        var data = [];

        var date = new Date();
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        let header1 = ["仓库", "日期", "坏件入库单号", "关联单号", "采购单号", "商品编码", "商品名称", "规格", "类别", "入库数", "出库数", "备注"]
        let column1 = ["cangkuname", "accdate", "erpserial", "ordernum", "buyordernum", "seedcode", "seedname", "packagesize", "leib", "rukunum", "chukunum", "remark"]
        for (let i in this.tableData) {
          var row = this.tableData[i];
          data.push({
            cangkuname: row.cangkuname,
            seedcode: row.seedcode,
            seedname: row.seedname,
            accdate: row.accdate,
            erpserial: row.erpserial,
            ordernum: row.ordernum,
            buyordernum: row.buyordernum,
            packagesize: this.getPackagesize(row.packagesize),
            leib: row.formtype.toString() == '78' ? row.ordername : row.handlemode,
            rukunum: row.formtype.toString() == '78' && row.totalnumber != 0 ? row.totalnumber : "",
            chukunum: row.formtype.toString() == '79' && row.totalnumber != 0 ? row.totalnumber : "",
            remark: row.remark
          });
        }

        var name = '坏件库明细' + y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length)
        this.$exportExcel(header1, column1, data, name)
      },
      tabClick(tab, event) {
        this.showtab = 1;
        this.currentcomponent = "";
        this.defaulttabname = tab.name;
        if (this.defaulttabname == 'daichuku') {
          this.showtab = 1;//出入库明细的Table 待补充
          this.bindTwoDimens()
        } else {
          this.showtab = 2;
        }
      },
      bindTwoDimens() {
        this.initContent = []
        this.initContentLeft = []
        this.initContentRight = []
        if (this.showtab == 1) {
          for (let j in this.tableData) {
            if (this.tableData[j].packagesize && this.tableData[j].packagesize != '') {
              var ps = JSON.parse(this.tableData[j].packagesize);
              var P = this.tableData[j].totalnumber;

              if (!P || P == 0) {
                P = ''
              }
              ps.P = P
              if (this.filltemplate == "30") {//左右眼
                if (ps.type == "L")
                  this.initContentLeft.push(ps)
                else
                  this.initContentRight.push(ps)
              } else {
                this.initContent.push(ps);
              }
            }
          }
          this.currentcomponent = "TwoDimensionalView";
          this.$nextTick(() => {
            this.showtab = 1;
          })
        }
      },
      getPackagesize(packagesize) {
        let s = ""
        if (packagesize) {
          let temp = JSON.parse(packagesize)
          if (temp.M)
            return temp.M + '-' + temp.C;

          s = "S:" + (parseFloat(temp.Y) > 0 ? "+" + temp.Y : temp.Y) + ",C:" + (parseFloat(temp.X) > 0 ? "+" + temp.X : temp.X)
          if (temp.type) {
            s = temp.type + ' ' + s;
          }
        }
        return s
      },
      //查看订单
      lookdingdan(serial) {
        if (!serial) {
          return;
        }

        switch (serial.substring(0, 2)) {
          case "78":
            this.$refs.BaoSunDetail.show(serial);
            break;
          case "79":
            this.$refs.StorageBadOut.show(serial);
            break;
          default:
            let row = {
              erpserial: serial
            }
            this.$refs.CstagreementEdit.initData(row)
            this.$refs.CstagreementEdit.show()
            break;
        }
      },
      initData(item, searchdata, date,jxcstoreData) {
        this.initialize();
        this.jxcstoreData=jxcstoreData;
        this.seedcode = item.seedcode;
        this.seedname = item.seedname;
        this.cangkucode = item.cangkucode
        this.searchdata = searchdata;
        this.date = date;
        this.filltemplate = item.filltemplate
        this.dialogFormVisible = true
        this.formtype = item.formtype
        this.title = '坏件库明细';//item.cangkuname+'  '+item.seedname

        this.bindGrid();
      },

      bindGrid() {
        this.tableData = []
        var SelDate = new Date(this.date)
        completeddetail({
          seedcode: this.seedcode,
          cangkucode: this.cangkucode,
          search: this.searchdata,
          yearflag: SelDate.getFullYear(),
          monthflag: SelDate.getMonth() + 1,
        }).then(response => {
          this.tableData = response.data.obj
          //this.bindTwoDimens()
          //this.editor()
        }).catch((error) => {
          console.log(error)
        });
      },
      //计算结存
      editor() {
        var obj = JSON.parse(JSON.stringify(this.tableData[0]));
        for (let i in obj) {
          if ("erpserial" == i) {
            obj[i] = '期初'
          } else {
            obj[i] = ''
          }
        }
        this.tableData.unshift(obj)
        var totalnum = 0
        for (let i in this.tableData) {
          if (i == 0) {
            this.tableData[i].subtractnum = 0
          }

          if (this.formtype == 78) {
            if (i > 0) {
              this.tableData[i].subtractnum = this.tableData[i - 1].subtractnum - this.tableData[i].totalnumber
              totalnum += this.tableData[i].totalnumber
            }

          } else if (this.formtype == 79) {
            if (i > 0) {
              this.tableData[i].subtractnum = this.tableData[i - 1].subtractnum + this.tableData[i].totalnumber
              totalnum += this.tableData[i].totalnumber
            }
          }
        }
        var heji = JSON.parse(JSON.stringify(this.tableData[0]));
        for (let i in heji) {
          if ("erpserial" == i) {
            heji[i] = '合计'
          } else if ("totalnumber" == i) {
            heji[i] = totalnum
          } else if ("subtractnum" == i) {
            heji[i] = this.tableData[this.tableData.length - 1].subtractnum
          } else {
            heji[i] = ''
          }
        }
        this.tableData.push(heji)
      },
      initialize() {
        this.seedcode = ''
        this.cangkucode = ''
        this.ordernum = ''
        this.showtab = 2
        this.defaulttabname = 'daichuku'
      }
    },
    mounted() {

    },
    components: {
      TwoDimensionalView,
      CstagreementEdit,
      StorageBadOut,
      BaoSunDetail,
      JxcgooddetailSel
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/warehouse/StorageBadDetail.vue